import * as THREE from 'three';

// Shared geometry/materials for the floating pickup boxes — one mesh per
// active box but they share the underlying GPU resources.
const BOX_GEO = new THREE.BoxGeometry(1.2, 1.2, 1.2);
const ACTIVE_MAT = new THREE.MeshStandardMaterial({
  color: 0xfde047,
  emissive: 0xfbbf24,
  emissiveIntensity: 0.75, // brighter so the box pops at distance
  roughness: 0.35,
  metalness: 0.3,
});
const INACTIVE_MAT = new THREE.MeshStandardMaterial({
  color: 0x94a3b8,
  transparent: true,
  opacity: 0.18,
});
const MARK_GEO = new THREE.SphereGeometry(0.18, 8, 8);
const MARK_MAT = new THREE.MeshStandardMaterial({
  color: 0x111827,
  emissive: 0x000000,
});

// One floating pickup box, hovering ~1.5m above the ground at its spawn
// location. update() rotates it and bobs it up/down for visibility; the
// active flag swaps materials so inactive (respawning) boxes go faded.
export class ItemBox {
  constructor(scene, position) {
    this.group = new THREE.Group();
    // Caller snaps position.y to the surface; we add a small hover so the
    // box visually sits just above the snow rather than embedded in it.
    this.group.position.set(position.x, position.y + 0.9, position.z);
    this.baseY = position.y + 0.9;

    this.mesh = new THREE.Mesh(BOX_GEO, ACTIVE_MAT);
    this.mesh.castShadow = true;
    this.group.add(this.mesh);

    // A small dark "?" sphere on each face direction so it reads as an
    // item marker rather than just a yellow cube.
    for (const [x, y, z] of [[0, 0, 0.62], [0, 0, -0.62], [0.62, 0, 0], [-0.62, 0, 0]]) {
      const dot = new THREE.Mesh(MARK_GEO, MARK_MAT);
      dot.position.set(x, y, z);
      this.group.add(dot);
    }

    scene.add(this.group);
    this.active = true;
  }

  setActive(active) {
    if (this.active === active) return;
    this.active = active;
    this.mesh.material = active ? ACTIVE_MAT : INACTIVE_MAT;
    // Hide the marker dots while respawning so the placeholder reads as
    // "not here yet".
    for (const child of this.group.children) {
      if (child !== this.mesh) child.visible = active;
    }
  }

  update(timeSec) {
    this.group.rotation.y = timeSec * 1.6;
    this.group.position.y = this.baseY + Math.sin(timeSec * 2.4) * 0.18;
  }

  destroy() {
    this.group.parent?.remove(this.group);
  }
}
